import { render } from "./ListeBureau.vue?vue&type=template&id=a130f320&ts=true"
import script from "./ListeBureau.vue?vue&type=script&lang=ts"
export * from "./ListeBureau.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__